import React from 'react';
import { 
  HomeIcon, 
  CubeIcon, 
  QrCodeIcon, 
  MicrophoneIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import { 
  HomeIcon as HomeIconSolid, 
  CubeIcon as CubeIconSolid, 
  QrCodeIcon as QrCodeIconSolid, 
  MicrophoneIcon as MicrophoneIconSolid,
  ChartBarIcon as ChartBarIconSolid
} from '@heroicons/react/24/solid';

interface MobileNavigationProps {
  currentPath: string;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ currentPath }) => {
  const navItems = [
    {
      name: 'Dashboard',
      href: '/app/dashboard',
      icon: HomeIcon,
      iconSolid: HomeIconSolid,
      active: currentPath === '/app/dashboard' || currentPath === '/app'
    },
    {
      name: 'Equipment',
      href: '/app/equipment',
      icon: CubeIcon,
      iconSolid: CubeIconSolid,
      active: currentPath === '/app/equipment'
    },
    {
      name: 'Scan',
      href: '/app/scan',
      icon: QrCodeIcon,
      iconSolid: QrCodeIconSolid,
      active: currentPath === '/app/scan'
    },
    {
      name: 'Voice',
      href: '/app/voice',
      icon: MicrophoneIcon,
      iconSolid: MicrophoneIconSolid,
      active: currentPath === '/app/voice'
    },
    {
      name: 'Reports',
      href: '/app/reports',
      icon: ChartBarIcon,
      iconSolid: ChartBarIconSolid,
      active: currentPath === '/app/reports'
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-50">
      <div className="flex justify-around">
        {navItems.map((item) => {
          const IconComponent = item.active ? item.iconSolid : item.icon;
          
          return (
            <a
              key={item.name}
              href={item.href}
              className={`flex flex-col items-center py-2 px-3 text-xs font-medium transition-colors ${
                item.active
                  ? 'text-blue-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <IconComponent className="w-6 h-6 mb-1" />
              <span className="truncate">{item.name}</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavigation;